import Vue from "vue"
import icons from "../components/icons"
Vue.use(icons)




// WEBPACK FOOTER //
// ./src/libs/global_components.js